export const componentStyles = {
  h1: {
    fontFamily: 'heading',
    fontSize: '6xl',
    fontWeight: 'normal',
    lineHeight: 'heading',
  },
  h2: {
    fontFamily: 'heading',
    fontSize: '5xl',
    fontWeight: 'normal',
    lineHeight: 'heading',
  },
  h3: {
    fontFamily: 'heading',
    fontSize: '4xl',
    fontWeight: 'normal',
    lineHeight: 'heading',
  },
  h4: {
    fontFamily: 'heading',
    fontSize: '3xl',
    fontWeight: 'normal',
    lineHeight: 'heading',
  },
  h5: {
    fontFamily: 'heading',
    fontSize: '2xl',
    fontWeight: 'normal',
    lineHeight: 'heading',
  },
  h6: {
    fontFamily: 'heading',
    fontSize: 'xl',
    fontWeight: 'normal',
    lineHeight: 'heading',
  },
  lead: {
    fontFamily: 'body',
    fontSize: 'lg',
    fontWeight: 'medium',
    lineHeight: 'body',
  },
  body1: {
    fontFamily: 'body',
    fontSize: 'base',
    fontWeight: 'normal',
    lineHeight: 'body',
  },
  body2: {
    fontFamily: 'body',
    fontSize: 'sm',
    fontWeight: 'normal',
    lineHeight: 'body',
  },
  a: {
    color: 'blue.500',
    cursor: 'pointer',
    outline: 'none',
    textDecoration: 'none',
    ':hover': {
      textDecoration: 'underline',
    },
  },
  em: {
    fontStyle: 'italic',
  },
  strong: {
    fontWeight: 'medium',
  },
  small: {
    fontSize: 'xs',
  },
  code: {
    fontFamily: 'mono',
    fontSize: 'base',
    fontWeight: 'normal',
    lineHeight: 'body',
  },
  pre: {
    fontFamily: 'monospace',
    overflowX: 'auto',
    code: {
      color: 'inherit',
    },
  },
};
